import { render, staticRenderFns } from "./ModalCancelarDados.vue?vue&type=template&id=8e8fc0c0&scoped=true"
import script from "./ModalCancelarDados.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCancelarDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalCancelarDados.vue?vue&type=style&index=0&id=8e8fc0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8fc0c0",
  null
  
)

export default component.exports